const vars = {
  sitekey: "6LcA2lMqAAAAAOSZ5t46imYnidg4AY_RtNqGXBGr",
  baseUrl: "https://api-mpp.dev.cloudsvc.megacable.com.mx/payportal",
  publicKey: '-----BEGIN PUBLIC KEY-----' +
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDLuQrG8tqsf8fwc6y3A6yR9FGf' +
    'fqWeEOnN+PrWyalM+smPQSAfaqEX1fgsVIGsj9dXjK7pNh4JYqmUmBBb14JQ6IJu' +
    'SGpXeQy2Z1lZsBfE4YXWQOy0/D1CIbR1IOEHkgQS+ISkUPYjrAFk9uGZxHbZH5mH' +
    'zMAH4TtnpHFNpTtUzwIDAQAB' +
    '-----END PUBLIC KEY-----'
}
export default vars;